export default {
  show: true,
  title:
    "What’s new: Flows V2, New Filter in Charts, New System Audiences, and more.",
  link: {
    href: "https://apphud.com/blog/apphud-product-updates-june-2025",
    title: "Let’s see",
  },
};
